export const INDEX_KEY = {
  expPV: 'expPV',
  expUV: 'expUV',
  clickPV: 'clickPV',
  clickUV: 'clickUV',
  introItemPV: 'introSkuDetailPV',
  introItemUV: 'introSkuDetailUV',
  directiveIntroOrderValue: 'directiveIntroOrderValue',
  directiveIntroParentOrderNums: 'directiveIntroParentOrderNums',
  uvClickRate: 'uvClickRate',
  uvDealRate: 'uvDealRate',
  directiveIntroUV: 'directiveIntroUV',
};
export const INDEX_GROUP = [
  {
    label: '商品曝光PV',
    value: INDEX_KEY.expPV,
  },
  {
    label: '商品曝光UV',
    value: INDEX_KEY.expUV,
  },
  {
    label: '商品点击PV',
    value: INDEX_KEY.clickPV,
  },
  {
    label: '商品点击UV',
    value: INDEX_KEY.clickUV,
  },
  {
    label: '引入商详PV',
    value: INDEX_KEY.introItemPV,
  },
  {
    label: '引入商详UV',
    value: INDEX_KEY.introItemUV,
  },
  {
    label: '直接引导成交订单金额',
    value: INDEX_KEY.directiveIntroOrderValue,
  },
  {
    label: '直接引导成交订单量',
    value: INDEX_KEY.directiveIntroParentOrderNums,
  },
  {
    label: '直接引导成交UV',
    value: INDEX_KEY.directiveIntroUV,
  },
  {
    label: 'UV点击率',
    value: INDEX_KEY.uvClickRate,
  },
  {
    label: 'UV成交率',
    value: INDEX_KEY.uvDealRate,
  },
];
export const INDEX_GROUP_MAP = {};

function transformArr2Map(data = [], res = {}) {
  data.forEach((item) => {
    res[item.value] = item.label;
  });
}
transformArr2Map(INDEX_GROUP, INDEX_GROUP_MAP);

export const DEFAULT_INDEX = [INDEX_KEY.expUV, INDEX_KEY.introItemUV, INDEX_KEY.directiveIntroOrderValue];
